
    import {
        defineComponent,
    } from 'vue';
    import Dropdown from '@ve/components/dropdown/desktop/Dropdown.vue';
    import IsExclusiveFilter from '@ve/components/filters/isExclusiveFilter/desktop/IsExclusiveFilter.vue';
    import WarrantedFilter from '@ve/components/filters/warrantedFilter/desktop/WarrantedFilter.vue';
    import DirectFlightFilterHotel from '@ve/components/filters/directFlightFilter/desktop/DirectFlightFilterHotel.vue';

    import asyncSvGLoader from '@ve/services/asyncSvgLoader';
    import IconBase from '@ve/services/IconBase.vue';

    import useAdditionalFiltersHotel from '../common/useAdditionalFiltersHotel';
    import iconArrow from './img/arrow.svg';

    export default defineComponent({
        name: 'additional-filters-hotel',
        components: {
            Dropdown,
            IsExclusiveFilter,
            WarrantedFilter,
            DirectFlightFilterHotel,
            IconBase,
            IconArrow: asyncSvGLoader(iconArrow),
        },
        setup(props, ctx) {
            return useAdditionalFiltersHotel(ctx);
        },
    });
